import React from 'react';

import * as messages from '@radnuc/messages';

import TimeAgo from './TimeAgo'
import MetricsDisplay from './MetricsDisplay'
import IsotopeDisplay from './IsotopeDisplay'
//import {IsotopeDisplay,TimeAgo} from '@radnuc/ui-components'
import ShareButtonDisplay from './ShareButtonDisplay'
import {SnoozeIsotopeButtonDisplay} from './SnoozeIsotopeDisplay'
import AudioAlertDisplay from './AudioAlert'
import { LaneDisplayInterface } from './PrimaryDisplay'
import ChemBioThreatDisplay from './ChemBioThreatDisplay'
import {AuthenticationInterface} from './AuthenticationDisplay'
import {CoralResults} from './ContextDisplay'
import {Config} from './Config'
import { uuidToString } from './UUID';
import {Textfit} from 'react-textfit';

import { t } from 'i18next';
import './i18n';
//import i18n from './i18n';

import './InvestigationDisplay.css'

import recycle_logo from './img/Recycle_bin_-32.png'
import undo_logo from './img/undo-32.png'
import replay_logo from './img/eye-24-32.png'
import replay_white_logo from './img/eye-24-32-white.png'
import chem_alert_logo from './img/icon-chem-green.png'
import bio_alert_logo from './img/icon-biohazard-darkorange.png'
import rad_alert_logo from './img/icon-radiation-white.png'
import alert_logo from './img/icon-attention.png'
import i18n from './i18n';

type Investigation = messages.Encounter.Encounter | messages.Rad.Investigation;
type PCSResult = messages.Rad.PCSResult;
type NeutronResult = messages.Rad.NeutronResult;

export interface InvestigationInterface {
    select: (inv: Investigation) => void,
    unselect: () => void,
    dismiss: (inv: Investigation) => void,
    dismissAll?: () => void,
    finalize:(inv: Investigation) => void,
    replay: (inv: Investigation) => void,
    unreplay: () => void,
    acknowledge: (inv: Investigation) => void,
    setAlertAcknowledge:(flag:boolean) => void,
    setCollapse: (inv: Investigation, flag:boolean) => void,
    setInvTypeToShow?:(type:messages.Encounter.EncounterType|null) => void,
}

interface InvestigationCardProps {
    investigation: Investigation,
    selected: boolean,
    replaying: boolean,
    investigationsNotAcknowledged?: Investigation[],
    investigationsCollapsed?: Investigation[],
    investigationInterface: InvestigationInterface,
    coralResults?: CoralResults,
    displayAsLanes?: boolean,
    isPrimary?: boolean,
    laneDisplayInterface?: LaneDisplayInterface,
    showSourceLocationAsDirection?: boolean,
    useSourceHeadingAndSourceLanePositionForDirection?: boolean,
    showSnoozeIsotopeButton?: boolean,
    showPdfExport?: boolean,
    useDoseRateSIUnit?: boolean,
    authenticationInterface?: AuthenticationInterface,
    language? : string,
}

export interface InvestigationCardState {
    dismissed: boolean;
    collapsed: boolean;
    acknowledged: boolean;
    dismiss_dialog_show: boolean;
    share_success_state: number;
}

export class InvestigationCard extends React.Component<InvestigationCardProps, InvestigationCardState, {}> {
    card_element: React.RefObject<HTMLDivElement>;
    card_scroll_to_element: React.RefObject<HTMLDivElement>;
    timeoutTimer: NodeJS.Timeout | null;
    timer: number | null = null;

    constructor(props: InvestigationCardProps) {
        super(props)
        this.state = {
            dismissed: false,
            collapsed: false,
            acknowledged: true,
            dismiss_dialog_show: false,
            share_success_state: 0
        }

        this.card_element = React.createRef<HTMLDivElement>();
        this.card_scroll_to_element = React.createRef<HTMLDivElement>();

        this.timeoutTimer = null;
    }

    handleExpandCollapseClick(event: React.MouseEvent<HTMLElement>) {
        event.stopPropagation();
        this.setState(state => ({
            collapsed: !state.collapsed
        }));
        this.props.investigationInterface.setCollapse(this.props.investigation,!this.state.collapsed)
    }

    handleSelectClick(event: React.MouseEvent<HTMLElement>) {
        event.stopPropagation();
        if (this.props.selected) {
            this.props.investigationInterface.unselect();
        } else {
            this.props.investigationInterface.select(this.props.investigation);
        }
    }

    componentWillUnmount() {
        if (this.timeoutTimer !== null) {
            clearTimeout(this.timeoutTimer);
        }
        if (this.timer !== null)
            window.clearInterval(this.timer);
    }

    componentDidMount() {
        this.timer = window.setInterval(() => this.updateFinalized(), 10000);
    }

    componentDidUpdate(prevProps: InvestigationCardProps) {
        if (this.props.selected && !prevProps.selected)
            this.scrollToThisCard();
        if(this.props.investigationsNotAcknowledged !== undefined){
            if(this.props.investigationsNotAcknowledged !== prevProps.investigationsNotAcknowledged)
                this.updateAcknowledged();
        }
        if(this.props.investigationsCollapsed !== undefined){
            if(this.props.investigationsCollapsed !== prevProps.investigationsCollapsed)
                this.updateCollapsed();
        }

        this.updateFinalized();

    }

    updateFinalized(){
        if(!this.props.investigation.finalized){
            if((new Date().getTime() - this.props.investigation.end_time) > 60000){ //360000){
                this.props.investigationInterface.finalize(this.props.investigation);
            }
        }
    }

    updateAcknowledged(){
        var acknowledged = true;
        if(this.props.investigationsNotAcknowledged !== undefined){
            if(this.props.investigationsNotAcknowledged.length > 0){
                this.props.investigationsNotAcknowledged.forEach((inv=>{
                    if(uuidToString(inv.id) === uuidToString(this.props.investigation.id)){
                        acknowledged = false;
                    }
                }))
            }
        }
        this.setState(state => ({
            acknowledged: acknowledged
        }));
    }

    updateCollapsed(){
        var collapsed = false;
        if(this.props.investigationsCollapsed !== undefined){
            if(this.props.investigationsCollapsed.length > 0){
                this.props.investigationsCollapsed.forEach((inv=>{
                    if(uuidToString(inv.id) === uuidToString(this.props.investigation.id)){
                        collapsed = true;
                    }
                }))
            }
        }
        this.setState(state => ({
            collapsed: collapsed
        }));
    }

    scrollToThisCard() {
        if (this.card_scroll_to_element.current != null) {
            this.card_scroll_to_element.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
    }

    handleReplayClick(event: React.MouseEvent<HTMLElement>) {
        event.stopPropagation();
        if (this.props.replaying) {
            this.props.investigationInterface.unreplay();
        } else {
            this.props.investigationInterface.replay(this.props.investigation);
        }
    }

    handleDismissClick(event: React.MouseEvent<HTMLElement>) {
        event.stopPropagation();
        this.setState(state => ({
            dismiss_dialog_show: !state.dismiss_dialog_show
        }));

        if (!this.state.dismiss_dialog_show) {
            if (this.timeoutTimer != null)
                clearTimeout(this.timeoutTimer);
            this.timeoutTimer = setTimeout(state => {
                this.setState(state => ({
                    dismiss_dialog_show: false
                }));
                this.timeoutTimer = null;
            }, 5000);
        }
    }

    handleDismissConfirmClick(event: React.MouseEvent<HTMLElement>) {
        event.stopPropagation();

        this.setState(() => ({
            dismissed: true
        }));
        setTimeout(() => {
            this.shrinkCardAnimation();
        }, 500);
        setTimeout(() => {
            this.props.investigationInterface.dismiss(this.props.investigation);
        }, 1000);
    }

    handleDismissCancelClick(event: React.MouseEvent<HTMLElement>) {
        event.stopPropagation();
        this.setState(() => ({
            dismiss_dialog_show: false
        }));
    }

    shrinkCardAnimation() {
        // Shrink height animation
        var element = this.card_element.current;
        if (element != null) {
            var sectionHeight = element.scrollHeight;
            // temporarily disable all css transitions
            var elementTransition = element.style.transition;
            element.style.transition = '';

            requestAnimationFrame(() => {
                if (element != null) {
                    element.style.height = sectionHeight + 'px';
                    element.style.transition = elementTransition;
                }
                requestAnimationFrame(() => {
                    if (element != null) {
                        element.style.height = 0 + 'px';
                    }
                });
            });
        }
    }

    renderRadElements(expanded?:boolean) {
        if(expanded === undefined)
            expanded = true;
        if(expanded){
            //Max Gamma and Dose Rate
            var gamma_rate = "N/A";
            if (this.props.investigation.max_count_rate !== null) {
                gamma_rate = this.props.investigation.max_count_rate.toFixed(1)
            }
            var dose_rate = "N/A";
            if (this.props.investigation.max_count_rate !== null) {
                if(this.props.useDoseRateSIUnit===true){
                    if(this.props.investigation.max_dose_rate/100 > 0.1) {
                        dose_rate = (this.props.investigation.max_dose_rate/100).toFixed(1)
                    } else {
                        dose_rate = (this.props.investigation.max_dose_rate/100).toFixed(2)
                    }
                } else {
                    dose_rate = this.props.investigation.max_dose_rate.toFixed(1)
                }
            }
            let dose_rate_unit_string;
            if(this.props.useDoseRateSIUnit===true){
                dose_rate_unit_string = t('μSv/hr',{ns:'trans'})
            } else {
                dose_rate_unit_string = t('μR/hr',{ns:'trans'})
            }
            const inv_rates =
                <div className="investigation-row">
                    <MetricsDisplay title={'Peak Gamma Rate'} value={gamma_rate} units={'cps'} style={undefined} />
                    <MetricsDisplay title={'Peak Dose Rate'} value={dose_rate} units={dose_rate_unit_string} style={undefined} />
                </div>

            var inv_isotopes =
                <IsotopeDisplay isotopes={this.props.investigation.isotopes} summary={false} hideConfidence={this.props.displayAsLanes}/>

            return (
                <>
                    {inv_rates}
                    {inv_isotopes}
                </>
            )
        } else {
            //collapsed
            return (
                <IsotopeDisplay isotopes={this.props.investigation.isotopes} summary={true} hideConfidence={this.props.displayAsLanes}/>
            )
        }

    }

    findMaxChemicalThreat(){
        let max_chem_name = "N/A"
        var max_concentration = "N/A";
        if('type' in this.props.investigation){
            if (this.props.investigation.chemicals !== null) {
                var max_conc = -1000000;
                var max_chemical = -1;
                const identifications = this.props.investigation.chemicals.identifications
                identifications.forEach((thisId:messages.SigmaPlusChem.ChemicalTargetIdentification) => {
                    if(thisId.concentration !== null){
                        if(thisId.concentration > max_conc){
                            max_conc = thisId.concentration;
                            max_chemical = thisId.chemical
                        }
                    }
                });
                if(max_conc > 0){
                    max_concentration = max_conc.toFixed(3)
                }
                if(max_chemical >=0){
                    max_chem_name = messages.SigmaPlusChem.SigmaPlusChemicalTarget[max_chemical];
                }
            }
        }
        return ({max_concentration:max_concentration , max_chem_name: max_chem_name});
    }

    renderChemElements(expanded?:boolean) {
        if(expanded === undefined)
            expanded = true;
        const result = this.findMaxChemicalThreat();
        //const result = {max_concentration:'1.0000' , max_chem_name: messages.SigmaPlusChem.SigmaPlusChemicalTarget[13]}
        if(expanded){
            return(
                <>
                    <div className="investigation-row">
                        <MetricsDisplay title={'Concentration'} value={result.max_concentration} units={'ppb'} style={{width:'100%'}} />
                    </div>
                    <div className="investigation-row">
                        <ChemBioThreatDisplay title={'Chemicals'} value={result.max_chem_name} units={''} style={{width:'100%'}}
                            threatStyle={{color:'white', wordWrap:'break-word',fontSize:'0.9em'}}/>
                    </div>
                </>
            )
        } else {
            //collapsed
            return (
                <div style={{color:'white',wordWrap:'break-word',fontSize:'0.9em'}}>
                    {result.max_chem_name}
                </div>
            )
        }
    }

    findMaxBiologicalThreat(){
        let bio_name = "N/A"
        let concentration = "N/A";
        if('type' in this.props.investigation){

            if (this.props.investigation.organism_name !== null && this.props.investigation.organism_name !== undefined) {
                bio_name = this.props.investigation.organism_name //OPTIONAL field TBD in encounter message
            }

        }
        return ({concentration:concentration , bio_name: bio_name});
    }

    renderBioElements(expanded?:boolean) {
        if(expanded === undefined)
            expanded = true;
        const result = this.findMaxBiologicalThreat()
        if(expanded){
            return(
                <>
                    <div className="investigation-row">
                        <ChemBioThreatDisplay title={'Organism'} value={result.bio_name} units={''} style={{width:'100%'}}
                            threatStyle={{color:'darkorange', wordWrap:'break-word',fontSize:'0.9em'}}/>
                    </div>
                </>
            )
        } else {
            //collapsed
            return (
                <div style={{color:'darkorange',wordWrap:'break-word',fontSize:'0.9em'}}>
                    {result.bio_name}
                </div>
            )
        }
    }

    pad(n:number) {return n < 10 ? "0"+n : n;}

    convertDateToString(dateobj:Date){
        if(i18n !== undefined){
            if(i18n.language === 'en'){
                return dateobj.toLocaleDateString();
            } else if(i18n.language === 'cz'){
                return [dateobj.getDate(), dateobj.getMonth()+1, dateobj.getFullYear()].join('.');
            } else if(i18n.language === 'hu'){
                return [dateobj.getFullYear(), this.pad(dateobj.getMonth()+1), this.pad(dateobj.getDate())].join('. ');
            } else if(i18n.language === 'ro'){
                return [dateobj.getDate(), dateobj.getMonth()+1, dateobj.getFullYear()].join('.');
            } else if(i18n.language === 'ru'){
                return [dateobj.getDate(), dateobj.getMonth()+1, dateobj.getFullYear()].join('.');
            } else if(i18n.language === 'sk'){
                return [dateobj.getDate(), dateobj.getMonth()+1, dateobj.getFullYear()].join('.');
            } else {
                return dateobj.toLocaleDateString();
            }
        } else {
            //Default
            return dateobj.toLocaleDateString();
        }
    }
    convertTimeToString(dateobj:Date){
        if(i18n !== undefined){
            if(i18n.language === 'en'){
                return dateobj.toLocaleTimeString();
            } else if(i18n.language === 'cz'){
                return [this.pad(dateobj.getHours()), this.pad(dateobj.getMinutes()), this.pad(dateobj.getSeconds())].join(':');
            } else if(i18n.language === 'hu'){
                return [this.pad(dateobj.getHours()), this.pad(dateobj.getMinutes()), this.pad(dateobj.getSeconds())].join(':');
            } else if(i18n.language === 'ro'){
                return [this.pad(dateobj.getHours()), this.pad(dateobj.getMinutes()), this.pad(dateobj.getSeconds())].join(':');
            } else if(i18n.language === 'ru'){
                return [this.pad(dateobj.getHours()), this.pad(dateobj.getMinutes()), this.pad(dateobj.getSeconds())].join(':');
            } else if(i18n.language === 'sk'){
                return [this.pad(dateobj.getHours()), this.pad(dateobj.getMinutes()), this.pad(dateobj.getSeconds())].join(':');
            } else {
                return dateobj.toLocaleTimeString();
            }
        } else {
            //Default
            return dateobj.toLocaleTimeString();
        }
    }

    convertDateTimeToString(dateobj:Date){
        if(i18n !== undefined){
            if(i18n.language === 'en'){
                return dateobj.toLocaleString();
            } else if(i18n.language === 'cz'){
                return [dateobj.getDate(), dateobj.getMonth()+1, dateobj.getFullYear()].join('. ')+', '+
                    [this.pad(dateobj.getHours()), this.pad(dateobj.getMinutes()), this.pad(dateobj.getSeconds())].join(':');
            } else if(i18n.language === 'hu'){
                return [dateobj.getFullYear(), this.pad(dateobj.getMonth()+1), this.pad(dateobj.getDate())].join('. ')+', '+
                    [this.pad(dateobj.getHours()), this.pad(dateobj.getMinutes()), this.pad(dateobj.getSeconds())].join(':');
            } else {
                return dateobj.toLocaleString();
            }
        } else {
            //Default
            return dateobj.toLocaleString();
        }
    }

    render() {
        //Expand/Collapse button
        var inv_expand_collapse;
        if (this.props.investigation.finalized) {
            var exp_collapse_string;
            if (!this.state.collapsed) {
                exp_collapse_string = '\u2212';
            } else {
                exp_collapse_string = '\u002B';
            }
            inv_expand_collapse =
                <div className="inv-exp-collapse-container" style={{ display: 'flex', cursor: 'pointer' }}
                        onClick={(event) => this.handleExpandCollapseClick(event)}>
                    <div className="inv-exp-collapse">{exp_collapse_string}</div>
                </div>
        }
        var timeAgo;
        if (this.props.investigation.finalized) {
            timeAgo = <TimeAgo lastEvent={new Date(this.props.investigation.end_time)} type={'inv'} />
        } else {
            timeAgo = <TimeAgo lastEvent={null} type={'inv'} />
        }

        //Investigation Title
        var title_string;
        let coralIndicator;
        if(this.props.isPrimary === undefined && this.props.displayAsLanes === undefined){
            // Default for mobile applications
            if (this.props.investigation.user_generated) {
                title_string = <div style={{ display: 'flex', flexDirection: 'row' }}><div className="inv-type-indicator">&#9733;</div>Manual Inv.</div>
            } else {
                title_string = 'Search Mode ';
                if('type' in this.props.investigation){
                    if(this.props.investigation.type !== undefined){
                        if(this.props.investigation.type === messages.Encounter.EncounterType.RAD){
                            title_string =  <div style={{ display: 'flex', flexDirection: 'row', overflow:'visible', color:'white', alignItems: 'center', width:'120px'}}>
                                                <div className="inv-type-indicator-img">
                                                    <img style={{background:'rbg(40,40,40)'}} className="inv-type-img" src={rad_alert_logo}/>
                                                </div>
                                                <div style={{width:'90px',height:'40px', lineHeight:'40px'}}>
                                                    <Textfit mode="single" forceSingleModeWidth={false} max={16} min={10}>
                                                        {t('Rad. Alert',{ns:'trans'})}
                                                    </Textfit>
                                                </div>
                                            </div>
                        } else if (this.props.investigation.type === messages.Encounter.EncounterType.CHEM){
                            title_string =  <div style={{ display: 'flex', flexDirection: 'row', overflow:'visible', color:'white', alignItems: 'center', width:'120px'}}>
                                                <div className="inv-type-indicator-img">
                                                    <img className="inv-type-img" src={chem_alert_logo}/>
                                                </div>
                                                <div style={{width:'90px',height:'40px', lineHeight:'40px'}}>
                                                    <Textfit mode="single" forceSingleModeWidth={false} max={16} min={10}>
                                                        {t('Chem. Alert',{ns:'trans'})}
                                                    </Textfit>
                                                </div>
                                            </div>

                            if(this.props.coralResults !== undefined && Object.keys(this.props.coralResults).length > 0){
                                const thisCoralResult = this.props.coralResults[uuidToString(this.props.investigation.id)];
                                if(thisCoralResult !== undefined){
                                    coralIndicator =
                                        <div style={{position: "relative"}}>
                                            <div style={{position: "absolute", top:'14px',left:'1px'}}>
                                                <div style={{display:'flex',alignItems:'center', fontWeight:'bold', fontSize:'0.4em',
                                                    borderRadius:"3px", backgroundColor:"coral",paddingLeft:'3px',paddingRight:'3px',paddingBottom:'1px',
                                                    whiteSpace:'nowrap', color:'#101010'}}>
                                                CORAL
                                                </div>
                                            </div>
                                        </div>
                                }
                            }

                        } else if (this.props.investigation.type === messages.Encounter.EncounterType.BIO){
                            title_string = <div style={{ display: 'flex', flexDirection: 'row', overflow:'visible', color:'white', alignItems: 'center', width:'120px'}}>
                                                <div className="inv-type-indicator-img">
                                                    <img className="inv-type-img" src={bio_alert_logo}/>
                                                </div>
                                                <div style={{width:'90px',height:'40px', lineHeight:'40px'}}>
                                                    <Textfit mode="single" forceSingleModeWidth={false} max={16} min={10}>
                                                        {t('Bio. Alert',{ns:'trans'})}
                                                    </Textfit>
                                                </div>
                                            </div>
                        } else {
                            title_string = <div style={{ display: 'flex', flexDirection: 'row', overflow:'visible', color:'', alignItems: 'center'}}>
                                                <div className="inv-type-indicator-img">
                                                    <img style={{background:''}} className="inv-type-img" src={alert_logo}/>
                                                </div>
                                                ALERT
                                            </div>
                        }
                    }
                }
            }
        } else if(!this.props.isPrimary){
            if(this.props.displayAsLanes){
                //SECONDARY
                title_string = 'SCAN ';
            }
        } else {
            if (this.props.investigation.user_generated) {
                title_string = <div style={{ display: 'flex', flexDirection: 'row' }}><div className="inv-type-indicator">&#9733;</div>Manual Inv.</div>
            } else {
                if(this.props.displayAsLanes){
                    //PRIMARY
                    title_string = 'ALERT ';
                } else {
                    title_string = 'Search Mode ';
                }
            }
        }
        const title =
            <div style={{ display: 'flex', flexDirection: 'row', alignContent: 'center', flexGrow: 1, justifyContent: 'space-between', alignItems: 'center', paddingRight:'2px'}}>
                {coralIndicator}
                <label className="inv-type metric" style={{overflow:'unset'}}>{title_string}</label>
                <label className="inv-timeago metric" style={{color: '#707070', marginLeft:'7px', width:'auto',minWidth:'55px'}}>
                    <Textfit mode="multi" max={12} min={10}>
                    {timeAgo}
                    </Textfit>
                </label>
            </div>
        var inv_title =
            <MetricsDisplay title={null} value={title} units={null} style={{ width: '100%', fontSize: '1em', display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center', minHeight: '30px' }} />

        let dateTimeFormatOptions = { year: 'numeric', month: 'numeric', day: 'numeric' };
        if(i18n !== undefined){
            if(i18n.language === 'en'){
                dateTimeFormatOptions = { year: 'numeric', month: 'numeric', day: 'numeric' };
            } else if(i18n.language === 'cz'){
                dateTimeFormatOptions = { year: 'numeric', month: 'numeric', day: 'numeric' };
            }
        }

        var inv_body;
        var start = new Date(this.props.investigation.start_time);
        var end = new Date(this.props.investigation.end_time);
        let dominant_lane_string:string | undefined
        if (this.state.collapsed) {
            //Collapsed shows start time and summary
            let inv_type_elements;
            if('type' in this.props.investigation){
                if(this.props.investigation.type === messages.Encounter.EncounterType.RAD){
                    inv_type_elements= this.renderRadElements(false);
                } else if(this.props.investigation.type === messages.Encounter.EncounterType.CHEM){
                    inv_type_elements= this.renderChemElements(false);
                } else if(this.props.investigation.type === messages.Encounter.EncounterType.BIO){
                    inv_type_elements= this.renderBioElements(false);
                }
            } else {
                //Default to Rad based display if investigation
                //Max Gamma and Dose Rate
                inv_type_elements= this.renderRadElements(false)
            }
            /*
            var  summary =
                <div className="investigation-column">
                    {start.toLocaleDateString() + " " + start.toLocaleTimeString()}
                    <IsotopeDisplay isotopes={this.props.investigation.isotopes} summary={true} hideConfidence={this.props.displayAsLanes}/>
                </div>
            */

//{start.toLocaleDateString() + " " + start.toLocaleTimeString()}
            var  summary =
                <div className="investigation-column">
                    {this.convertDateToString(start) + " " + this.convertTimeToString(start)}
                    {inv_type_elements}
                </div>

            var dismiss_hidden;
            if (this.props.investigation.finalized) {
                dismiss_hidden = <div className="inv-delete-all-hidden" style={{display:'none'}} onClick={this.handleDismissConfirmClick}/>
            }

            inv_body =
                <>
                    <div className="investigation-column">
                        <div className="investigation-row">
                            <MetricsDisplay title={null} value={summary} units={null} style={{ width: '100%' }} />
                        </div>
                    </div>
                    {/*INVISIBLE DIVS USED FOR EXPERT SETTINGS */}
                    <div className={'expertSettings'} style={{display:'none'}}>
                        {dismiss_hidden}
                        <ShareButtonDisplay investigation={this.props.investigation}
                            linked_dialog_showing={this.state.dismiss_dialog_show}
                            showPdfExport={this.props.showPdfExport}
                            style={{width: '230px' }} />
                    </div>
                </>

        } else {
            //Expanded
            //Investigation start and end times
            //<MetricsDisplay title={'Start Time'} value={start.toLocaleString()} units={null}
            const inv_times =
                <div className="investigation-row">
                    <MetricsDisplay title={'Start Time'} value={this.convertDateTimeToString(start)} units={null}
                        style={{ minHeight: '3em' }} valueAsIs={true}/>
                    <MetricsDisplay title={'End Time'} value={this.convertDateTimeToString(end)} units={null}
                        style={{ minHeight: '3em' }} valueAsIs={true}/>
                </div>
            let inv_locations;
            if(this.props.displayAsLanes){
                //Lane display
                var lane_loc = "N/A";
                if(this.props.isPrimary){
                    if(this.props.investigation.source_lane !== undefined){
                        if(this.props.investigation.source_lane !== null){
                            if(this.props.laneDisplayInterface?.laneNumberAndLabel){
                                this.props.laneDisplayInterface.laneNumberAndLabel.forEach((lane=>{
                                    if(lane.laneNumber === this.props.investigation.source_lane)
                                        lane_loc = lane.laneLabel.toString();
                                }));
                            } else {
                                lane_loc = (this.props.investigation.source_lane+1).toFixed(0);
                            }
                            dominant_lane_string = lane_loc;
                        }
                    }

                    //Display alternative attribution lane number
                    const alt_lane = AltAttributionUtil.getAltAttrSourceLaneLabel(this.props.investigation,this.props.laneDisplayInterface);
                    if(alt_lane){
                        lane_loc = lane_loc+', '+alt_lane;
                    }

                } else {
                    //SECONDARY
                    if(this.props.laneDisplayInterface?.laneNumberAndLabel){
                        this.props.laneDisplayInterface.laneNumberAndLabel.forEach((lane)=>{
                                lane_loc = lane.laneLabel.toString();;
                        });
                    }
                }
                inv_locations =
                    <div className="investigation-row">
                        <MetricsDisplay title={'Lane'} value={lane_loc} units={null} style={{width:'100%'}} />
                    </div>
            } else {
                //Vehicle Location and source location
                var veh_loc = "N/A";
                if (this.props.investigation.vehicle_location !== null) {
                    veh_loc = this.props.investigation.vehicle_location.latitude.toFixed(6) + ", " +
                        this.props.investigation.vehicle_location.longitude.toFixed(6);
                }
                var src_loc = "N/A";
                if(this.props.showSourceLocationAsDirection){
                    if(this.props.useSourceHeadingAndSourceLanePositionForDirection){
                        if(this.props.investigation.relative_bearing_to_source !== null){
                            if(this.props.investigation.relative_bearing_to_source === 90){
                                src_loc = "Right Side";
                            }
                            if(this.props.investigation.relative_bearing_to_source === 270){
                                src_loc = "Left Side";
                            }
                        } else if (this.props.investigation.source_lane_position !== null){
                            if(this.props.investigation.source_lane_position === 0){
                                src_loc = "Bottom";
                            }
                            if(this.props.investigation.source_lane_position === 1){
                                src_loc = "Top";
                            }
                        }
                    } else {
                        if(this.props.investigation.source_lane !== undefined){
                            if(this.props.investigation.source_lane !== null){
                                if(this.props.investigation.source_lane === 0){
                                    src_loc = "Left Side";
                                }
                                if(this.props.investigation.source_lane === 1){
                                    src_loc = "Right Side";
                                }
                            }
                        }
                    }
                } else {
                    if('source_location' in this.props.investigation){
                        if (this.props.investigation.source_location !== null) {
                            src_loc = this.props.investigation.source_location.latitude.toFixed(6) + ", " +
                                this.props.investigation.source_location.longitude.toFixed(6);
                        }
                    } else if ('isotope_location' in this.props.investigation) {
                        if (this.props.investigation.isotope_location !== null) {
                            src_loc = this.props.investigation.isotope_location.latitude.toFixed(6) + ", " +
                                this.props.investigation.isotope_location.longitude.toFixed(6);
                        }
                    }
                }

                inv_locations =
                    <div className="investigation-row">
                        <MetricsDisplay title={'Vehicle Location'} value={veh_loc} units={null} style={{ minHeight: '3em' }} />
                        <MetricsDisplay title={'Source Location'} value={src_loc} units={null} style={{ minHeight: '3em' }} />
                    </div>
            }

            let inv_type_elements;
            if('type' in this.props.investigation){
                if(this.props.investigation.type === messages.Encounter.EncounterType.RAD){
                    inv_type_elements= this.renderRadElements();
                } else if(this.props.investigation.type === messages.Encounter.EncounterType.CHEM){
                    inv_type_elements= this.renderChemElements();
                } else if(this.props.investigation.type === messages.Encounter.EncounterType.BIO){
                    inv_type_elements= this.renderBioElements();
                }
            } else {
                //Default to Rad based display if investigation
                //Max Gamma and Dose Rate
                var gamma_rate = "N/A";
                if (this.props.investigation.max_count_rate !== null) {
                    gamma_rate = this.props.investigation.max_count_rate.toFixed(1)
                }
                var dose_rate = "N/A";
                if (this.props.investigation.max_count_rate !== null) {
                    if(this.props.useDoseRateSIUnit===true)
                    if(this.props.investigation.max_dose_rate/100 > 0.1) {
                        dose_rate = (this.props.investigation.max_dose_rate/100).toFixed(1)
                    } else {
                        dose_rate = (this.props.investigation.max_dose_rate/100).toFixed(2)
                    }
                    else
                        dose_rate = this.props.investigation.max_dose_rate.toFixed(1)
                }
                let dose_rate_unit_string;
                if(this.props.useDoseRateSIUnit===true){
                    dose_rate_unit_string = '\u00B5Sv/hr'
                } else {
                    dose_rate_unit_string = '\u00B5R/hr'
                }
                const inv_rates =
                    <div className="investigation-row">
                        <MetricsDisplay title={'Peak Gamma Rate'} value={gamma_rate} units={'cps'} style={undefined} />
                        <MetricsDisplay title={'Peak Dose Rate'} value={dose_rate} units={dose_rate_unit_string} style={undefined} />
                    </div>

                const inv_isotopes =
                    <IsotopeDisplay isotopes={this.props.investigation.isotopes}
                                    laneLabel={dominant_lane_string}
                                    altIsotopes={AltAttributionUtil.getAltAttrSourceIsotopes(this.props.investigation)}
                                    altLaneLabel={AltAttributionUtil.getAltAttrSourceLaneLabel(this.props.investigation,this.props.laneDisplayInterface)}
                                    summary={false} hideConfidence={this.props.displayAsLanes}/>
                inv_type_elements =
                    <>
                        {inv_rates}
                        {inv_isotopes}
                    </>
            }

            //Buttons
            var dismiss_button;
            if (this.props.investigation.finalized) {
                dismiss_button =
                    <>
                        <div className="inv-dismiss-container inv-menu-item" style={{ display: 'flex', cursor: 'pointer' }}
                                onClick={(event) => this.handleDismissClick(event)}>
                            <img src={recycle_logo} alt="Delete" className="inv-delete inv-menu-button"></img>
                        </div>
                        <div className="inv-delete-all-hidden" style={{display:'none'}}
                                onClick={(event) => this.handleDismissConfirmClick(event)}/>
                    </>
            } else {
                dismiss_button =
                    <div className="inv-dismiss-container-spacer">
                        <img src={recycle_logo} alt="Delete" style={{ opacity: '0.1' }}></img>
                    </div>
            }

            var dismiss_dialog;
            if (this.state.dismiss_dialog_show) {
                dismiss_dialog =
                    <div className="inv-dismiss-dialog-container inv-menu-item"
                            style={{ display: 'flex', width: '100%', height: '40px', opacity: '1.0' }}>
                        <div className="inv-dismiss-undo-container inv-menu-item">
                            <img src={undo_logo} alt="Cancel Delete" className="inv-delete-undo inv-menu-button"
                                style={{ cursor: 'pointer' }}
                                onClick={(event) => this.handleDismissCancelClick(event)}></img>
                        </div>
                        <div className="inv-dismiss-confirm-container inv-menu-item">
                            <img src={recycle_logo} alt="Confirm Delete" className="inv-delete-confirm inv-menu-button"
                                style={{ cursor: 'pointer' }}
                                onClick={(event) => this.handleDismissConfirmClick(event)}></img>
                        </div>
                    </div>
            }

            let shareAndSnoozeIsopeButton;
            if(this.props.showSnoozeIsotopeButton){
                shareAndSnoozeIsopeButton =
                    <>
                        <ShareButtonDisplay investigation={this.props.investigation}
                            linked_dialog_showing={this.state.dismiss_dialog_show}
                            showPdfExport={this.props.showPdfExport}
                            style={{ width: '250px', left:'33px'}} />
                        <SnoozeIsotopeButtonDisplay investigation={this.props.investigation}
                            linked_dialog_showing={this.state.dismiss_dialog_show}
                            style={{ width: '250px', left:'-33px'}}
                            authenticationInterface={this.props.authenticationInterface}/>
                    </>
            } else {
                shareAndSnoozeIsopeButton =
                        <ShareButtonDisplay investigation={this.props.investigation}
                            linked_dialog_showing={this.state.dismiss_dialog_show}
                            showPdfExport={this.props.showPdfExport}
                            style={{ width: '250px' }} />
            }

            var buttons =
                <div className="investigation-row" style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', paddingTop: '5px' }}>
                    <div className="inv-replay-container-spacer">
                        <img src={this.props.replaying? replay_white_logo: replay_logo} alt="Toggle Replay" style={{ cursor: 'pointer' }}
                            onClick={(event) => this.handleReplayClick(event)} />
                    </div>
                    {shareAndSnoozeIsopeButton}
                    {dismiss_button}
                </div>

            inv_body =
                <div className="investigation-column">
                    {inv_times}
                    {inv_locations}
                    {inv_type_elements}
                    {buttons}
                    {dismiss_dialog}
                </div>
        }

        var investigationCardClasses = 'InvestigationCard';
        if (!this.props.investigation.finalized) {
            investigationCardClasses += ' active';
        }
        if (this.state.dismissed) {
            investigationCardClasses += ' dismissed';
        }
        if (this.props.selected) {
            investigationCardClasses += ' selected';
        }
        if (this.props.replaying) {
            investigationCardClasses += ' replaying';
        }
        if (!this.state.acknowledged) {
            investigationCardClasses += ' acknowledge';
        }

        return (
            <div className={investigationCardClasses} onClick={(event) => this.handleSelectClick(event)}
                    ref={this.card_element}>
                <div ref={this.card_scroll_to_element} style={{ position: 'relative', top: '-10px' }} />
                <div className="investigation-column">
                    <div className="investigation-row">
                        {inv_title}
                        {inv_expand_collapse}
                    </div>
                    {inv_body}
                </div>
            </div>
        )
    }
}
const MemoizedInvestigationCard = React.memo(InvestigationCard,cardsAreEqual);

function cardsAreEqual(prevProps:InvestigationCardProps,nextProps:InvestigationCardProps){

        const flag = prevProps.investigation === nextProps.investigation &&
                    prevProps.selected === nextProps.selected &&
                    prevProps.replaying === nextProps.replaying &&
                    prevProps.investigationsNotAcknowledged?.length === nextProps.investigationsNotAcknowledged?.length &&
                    prevProps.useDoseRateSIUnit === nextProps.useDoseRateSIUnit &&
                    prevProps.coralResults === nextProps.coralResults &&
                    prevProps.language === nextProps.language &&
                    prevProps.investigation.finalized === nextProps.investigation.finalized

        //if(prevProps.coralResults !== nextProps.coralResults){
        //    console.log('coral results different!')
        //}
        return (flag);
}
//******************************************************************************
interface InvestigationDisplayProps {
    investigations: Investigation[],
    currentPCSResult: PCSResult | null,
    currentNeutronResult: NeutronResult | null,

    coralResults?: CoralResults,
    selectedInvestigation?: Investigation,
    replayInvestigation?: Investigation,
    investigationsNotAcknowledged?: Investigation[],
    investigationsCollapsed?: Investigation[],
    investigationInterface: InvestigationInterface,
    displayAsLanes?: boolean,
    isPrimary?: boolean,
    laneDisplayInterface?: LaneDisplayInterface,
    numInvInitialLoad?: number,
    numInvLoadIncrement?: number,
    showAudioControl?: boolean,
    disableMuteForOne?: boolean,
    showSourceLocationAsDirection?: boolean,
    useSourceHeadingAndSourceLanePositionForDirection?: boolean,
    invTypeToShow?: messages.Encounter.EncounterType|null,
    useTTSVoice?: string,
    showSnoozeIsotopeButton?: boolean,
    authenticationInterface?: AuthenticationInterface,
    useDoseRateSIUnit?: boolean,
    showPdfExport?: boolean,
    config?: Config,
}

interface InvestigationDisplayState {
    maxNumToDisplay: number,
}
export class InvestigationDisplay extends React.Component<InvestigationDisplayProps, InvestigationDisplayState> {
    display_element: React.RefObject<HTMLDivElement>;
    inv_load_init: number = this.props.numInvInitialLoad?  this.props.numInvInitialLoad : 50;
    inv_load_increment: number = this.props.numInvLoadIncrement?  this.props.numInvLoadIncrement : 50;
    displayed_to_time: number;
    latest_inv_time: number;

    constructor(props: InvestigationDisplayProps) {
        super(props)
        this.state={
            maxNumToDisplay: this.inv_load_init,
        }
        this.latest_inv_time = new Date().getTime();
        this.displayed_to_time = new Date().getTime();
        this.display_element = React.createRef<HTMLDivElement>();
        this.handleShowMoreClick = this.handleShowMoreClick.bind(this);
        this.handleInvTypeSelectClick = this.handleInvTypeSelectClick.bind(this);
    }

    componentDidUpdate(prevProps: InvestigationDisplayProps) {
        if (this.display_element.current !== null) {
            if(this.props.investigations.length > prevProps.investigations.length) {
                if(this.props.replayInvestigation === undefined) {
                    //Scroll to top only if not in replay mode
                    if(this.props.investigations[0].start_time > this.latest_inv_time){
                        const num_inv_diff = this.props.investigations.length - prevProps.investigations.length;
                        //New Investigation was added
                        const list = this.display_element.current;
                        //list.scrollTop = 0;
                        list.scrollTo({
                            top:0,
                            behavior:'smooth'
                        })
                        this.latest_inv_time = this.props.investigations[0].start_time;
                        this.setState(state=>({
                            maxNumToDisplay: state.maxNumToDisplay + num_inv_diff
                        }));
                    }
                }
            } else if(this.props.replayInvestigation === undefined && prevProps.replayInvestigation !== undefined){
                //Scroll back to unacknowledged alerts upon exiting from replay
                if(this.props.investigationsNotAcknowledged){
                    if(this.props.investigationsNotAcknowledged.length > 0){
                        const list = this.display_element.current;
                        list.scrollTo({
                            top:0,
                            behavior:'smooth'
                        })
                    }
                }
            }
        }
    }

    handleShowMoreClick(){
        //console.log('Load More Clicked');
        this.setState(state=>({
            maxNumToDisplay: state.maxNumToDisplay + this.inv_load_increment
        }));
    }

    handleInvTypeSelectClick(){
        if(this.props.invTypeToShow !== undefined){
            if(this.props.investigationInterface !== undefined && this.props.investigationInterface.setInvTypeToShow !== undefined){
                //Cycle between ALL -> RAD Only -> Chem Only -> Bio Only
                if(this.props.invTypeToShow === null){
                    this.props.investigationInterface.setInvTypeToShow(messages.Encounter.EncounterType.RAD);
                } else if(this.props.invTypeToShow === messages.Encounter.EncounterType.RAD){
                    this.props.investigationInterface.setInvTypeToShow(messages.Encounter.EncounterType.CHEM);
                } else if(this.props.invTypeToShow === messages.Encounter.EncounterType.CHEM){
                    this.props.investigationInterface.setInvTypeToShow(messages.Encounter.EncounterType.BIO);
                } else {
                    this.props.investigationInterface.setInvTypeToShow(null);
                }
            }
        }
    }


    render() {
        let investigations = this.props.investigations;
        let investigationToDisplay = investigations.slice(0,this.state.maxNumToDisplay)

        const cards = investigationToDisplay.map((inv) =>
            <MemoizedInvestigationCard key={uuidToString(inv.id)}
                investigation={inv}
                selected={inv.id === this.props.selectedInvestigation?.id}
                replaying={inv.id === this.props.replayInvestigation?.id}
                investigationsNotAcknowledged={this.props.investigationsNotAcknowledged}
                investigationsCollapsed={this.props.investigationsCollapsed}
                investigationInterface={this.props.investigationInterface}
                coralResults={this.props.coralResults}
                displayAsLanes={this.props.displayAsLanes}
                isPrimary={this.props.isPrimary}
                showSourceLocationAsDirection={this.props.showSourceLocationAsDirection}
                useSourceHeadingAndSourceLanePositionForDirection={this.props.useSourceHeadingAndSourceLanePositionForDirection}
                laneDisplayInterface={this.props.laneDisplayInterface}
                showSnoozeIsotopeButton={this.props.showSnoozeIsotopeButton}
                showPdfExport={this.props.showPdfExport}
                useDoseRateSIUnit={this.props.useDoseRateSIUnit}
                authenticationInterface={this.props.authenticationInterface}
                language={i18n.language}/>
        );

        const exitReplay = this.props.replayInvestigation?
            <div id="ExitReplay" className="round-button" onClick={() => this.props.investigationInterface.unreplay()} style={{height:'22px'}}>
                <Textfit mode="single" forceSingleModeWidth={true} max={14} min={10}>
                    {t('Exit Replay',{ns:'trans'})}
                </Textfit>
            </div> : <></>;

        const invLeftToDisplay = investigations.length-investigationToDisplay.length;
        const invShowString = (invLeftToDisplay > this.inv_load_increment) ? t("Show N more",{number:this.inv_load_increment.toFixed(0),ns:'trans'}) : t("Show All",{ns:'trans'});
        const loadMore = (invLeftToDisplay > 0) ?
            <div id="ShowMore" className="round-button" onClick={this.handleShowMoreClick}>
                <Textfit mode="single" forceSingleModeWidth={false} max={16} min={12}>
                {invShowString} ({t('N left',{number:invLeftToDisplay,ns:'trans'})})
                </Textfit>
            </div> : <></>;
        let hideAudioControl = true;
        let isSecondary:boolean|undefined;
        if(this.props.isPrimary === undefined){
            isSecondary = undefined;
        } else {
            isSecondary = !this.props.isPrimary;
        }
        if(this.props.showAudioControl === true){
            hideAudioControl = false;
        }

        let invTypeToShowImg;
        if(this.props.invTypeToShow === null){
            invTypeToShowImg =
                <>
                    <img style={{background:'rbg(40,40,40)', height:'16px', width:'16px',marginLeft:'5px'}} className="inv-type-img" src={rad_alert_logo} title={'RAD'}/>
                    <img style={{background:'rbg(40,40,40)', height:'16px', width:'16px',marginLeft:'5px'}} className="inv-type-img" src={chem_alert_logo} title={'CHEM'}/>
                    <img style={{background:'rbg(40,40,40)', height:'16px', width:'16px',marginLeft:'5px'}} className="inv-type-img" src={bio_alert_logo} title={'BIO'}/>
                </>
        } else if (this.props.invTypeToShow === messages.Encounter.EncounterType.RAD){
            invTypeToShowImg =
                    <img style={{background:'rbg(40,40,40)', height:'16px', width:'16px',marginLeft:'5px'}} className="inv-type-img" src={rad_alert_logo} title={'RAD'}/>
        } else if (this.props.invTypeToShow === messages.Encounter.EncounterType.CHEM){
            invTypeToShowImg =
                    <img style={{background:'rbg(40,40,40)', height:'16px', width:'16px',marginLeft:'5px'}} className="inv-type-img" src={chem_alert_logo} title={'CHEM'}/>
        } else if (this.props.invTypeToShow === messages.Encounter.EncounterType.BIO){
            invTypeToShowImg =
                    <img style={{background:'rbg(40,40,40)', height:'16px', width:'16px',marginLeft:'5px'}} className="inv-type-img" src={bio_alert_logo} title={'BIO'}/>
        }

        const alertSwitch = (invTypeToShowImg !== undefined) ?
            <div id="AlertSwitch" className="round-button" style={{margin:'10px',marginRight:'5px',marginTop:'0px'}}onClick={this.handleInvTypeSelectClick}>
                Alerting on {invTypeToShowImg}
            </div> : <></>;

        return (
            <>
            <div className="InvestigationDisplay" >
                <div className="header">
                    <span>{t('Alerts',{ns:'trans'})}</span>
                    {exitReplay}
                    <AudioAlertDisplay investigations={investigations}
                        investigationsNotAcknowledged={this.props.investigationsNotAcknowledged}
                        currentPCSResult={this.props.currentPCSResult}
                        currentNeutronResult={this.props.currentNeutronResult}
                        hidden={hideAudioControl}
                        isSecondary={isSecondary}
                        disableMuteForOne={this.props.disableMuteForOne}
                        convertLaneToDirection={this.props.showSourceLocationAsDirection}
                        useSourceHeadingAndSourceLanePositionForDirection={this.props.useSourceHeadingAndSourceLanePositionForDirection}
                        laneToAlarm={this.props.laneDisplayInterface?.laneToDisplay}
                        laneDisplayInterface={this.props.laneDisplayInterface}
                        useTTSVoice={this.props.useTTSVoice}
                        config={this.props.config}
                        authenticationInterface={this.props.authenticationInterface}/>
                </div>
                <div className={`body ${this.props.replayInvestigation ? 'replay' : ''}`} ref={this.display_element}>
                    {cards}
                    {loadMore}
                </div>
            </div>
            {alertSwitch}
            </>
        )
    }
}

export default InvestigationDisplay

export class AltAttributionUtil {

    static getAltAttrSourceLaneLabel(inv:Investigation, laneDisplayInterface?:LaneDisplayInterface) {
        let lane_string:string|undefined;
        if('type' in inv){
            //ENCOUNTER
        } else {
            if(inv.alternative_attributions !== undefined && inv.alternative_attributions !== null && inv.alternative_attributions.length > 0){
                    inv.alternative_attributions.forEach((attr=>{
                        if(attr.source_lane !== undefined && attr.source_lane !== null){
                                if(laneDisplayInterface?.laneNumberAndLabel){
                                    laneDisplayInterface.laneNumberAndLabel.forEach((lane=>{
                                        if(lane.laneNumber === attr.source_lane)
                                            lane_string = lane.laneLabel.toString();
                                    }));
                                } else {
                                    lane_string = (attr.source_lane+1).toFixed(0);
                                }
                        }
                    }));
            }
        }
        return lane_string;
    }

    static getAltAttrSourceIsotopes(inv:Investigation) {
        let isotopes:messages.Rad.IsotopeResult[]|undefined;
        if('type' in inv){
            //ENCOUNTER
        } else {
            if(inv.alternative_attributions !== undefined && inv.alternative_attributions !== null && inv.alternative_attributions.length > 0){
                    inv.alternative_attributions.forEach((attr=>{
                        isotopes = attr.isotopes;
                    }));
            }
        }
        return isotopes;
    }

    static isAltAttrInThisLane(inv:Investigation, lanePosition?: number|undefined) {
        let result = false;
        if('type' in inv){
            //ENCOUNTER
        } else {
            if(inv.alternative_attributions !== undefined && inv.alternative_attributions !== null){
                inv.alternative_attributions.forEach((attr=>{
                    if(attr.source_lane !== undefined && attr.source_lane !== null){
                        if(attr.source_lane === lanePosition){
                            if(attr.isotopes.length > 0)
                                result = true;
                        } else if (lanePosition===undefined){
                            //Lane position undefined means it is in multilane display
                            if(attr.isotopes.length > 0)
                                result = true;
                        }
                    }
                }));
            }
        }
        return result;
    }

    static getAltAttrIsotopeName(inv:Investigation) {
        let name="";
        if('type' in inv){
            //ENCOUNTER
        } else {
            if(inv.alternative_attributions !== undefined && inv.alternative_attributions !== null && inv.alternative_attributions.length > 0){
                let attr = inv.alternative_attributions[0];
                if(attr.isotopes !== undefined && attr.isotopes !== null){
                    if(attr.isotopes.length > 0)
                        name = attr.isotopes[0].name;
                }
            }
        }
        return name;
    }

    static getAltAttrIsotopeCategory(inv:Investigation) {
        let category="";
        if('type' in inv){
            //ENCOUNTER
        } else {
            if(inv.alternative_attributions !== undefined && inv.alternative_attributions !== null && inv.alternative_attributions.length > 0){
                let attr = inv.alternative_attributions[0];
                if(attr.isotopes !== undefined && attr.isotopes !== null){
                    if(attr.isotopes.length > 0)
                        category = attr.isotopes[0].category;
                }
            }
        }
        return category;
    }

    static getAltAttrImageId(inv:Investigation | undefined) {
        let image_id = null;
        if(inv === undefined)
            return image_id;
            if('type' in inv){
                //ENCOUNTER
        } else {
            if(inv.alternative_attributions !== undefined && inv.alternative_attributions !== null && inv.alternative_attributions.length > 0){
                let attr = inv.alternative_attributions[0];
                if(attr.image !== undefined && attr.image !== null){
                    image_id = attr.image;
                }
            }
        }
        return image_id;
    }


}
